import styled from 'styled-components'

export const DescriptionContainer = styled.div`
    padding: 25px;
`